import styled from "styled-components";
import { device } from "../../../utils/helpers/breakpoints";

export const SectionDetailsStyle = styled.div`
  padding-top: 2rem;
  margin-bottom: 20px;

  > h5 {
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
  }
`;

export const DetailsArea = styled.div`
  display: grid;
  grid-template-columns: 4fr 8fr;
  gap: 20px;

  @media ${device.tablet} {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & > div > div:nth-child(1) {
    margin-bottom: 3rem;
  }
`;

export const Summary = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: #aaaaaa;
  max-width: 371px;
`;

export const Data = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 20px;

  @media ${device.mobile} {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const Details = styled.div`
  margin-bottom: 20px;

  > p {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }

  > span {
    font-size: 14px;
    line-height: 22px;
    color: #aaaaaa;
  }
`;

export const FileContainer = styled.div`
  margin-top: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 8.313rem;
  width: 28.438rem;
  border-radius: ${(props) => props.theme.borderRadius.sm};
  background: #fefffe;
  border: 0.063rem solid rgba(209, 218, 221, 0.5);

  p {
    padding-top: 0.625rem;
    font-size: ${(props) => props.theme.fontSize["h4"].fontSize};
    line-height: ${(props) => props.theme.fontSize["h4"].lineHeight};
    color: ${(props) => props.theme.colors.uburuBlack};
  }

  @media ${device.tablet} {
    margin-right: 1.25rem;
    width: 95%;
  }

  @media ${device.mobile} {
    margin-right: 1.25rem;
    width: 93%;
  }
`;
